import mapStyles from "./mapStyles";

const config = {
    styles: mapStyles,
    scrollwheel: false,
    mapTypeControl: false,
    draggable: true,
    navigationControl: false,
    disableDoubleClickZoom: true,
    disableDefaultUI: true,
    scaleControl: false,
    zoomControl: true,
    maxZoom: 20,
};

export default config;
